import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';  
import { externalApiService } from '../services/externalApiService';  

export const sendActionStatus = createAsyncThunk<
    any, 
    { token: string, status:boolean, action:string, message?:string | "", redirection?:string |"" },
  { rejectValue: string }
  >('externalApis/sendActionStatus', async ({token, status, action, message, redirection}, { rejectWithValue }) => {
  try {
    const response = await externalApiService.sendActionStatus(token, status, action, message, redirection);
    return response;
  } catch (error: any) {
    return rejectWithValue('An unexpected error occurred');
  }
});  
 
const externalApiReducer = createSlice({
  name: 'lookup',
  initialState : {},
  reducers: {},
  extraReducers: (builder) => { 
  },
});

export default externalApiReducer.reducer; 
